import { TradingBlockApplicationCategoryNameDto } from 'src/dtos';
import { MTypography } from 'src/lib';
import { Color, Spacing } from 'src/styles';

interface CipFailureDescriptionProps {
  category: TradingBlockApplicationCategoryNameDto;
}

export const ApplicationCipFailureDescription = ({ category }: CipFailureDescriptionProps) => {
  if (category === TradingBlockApplicationCategoryNameDto.AffiliateApproval) {
    return (
      <div className={Spacing.mb16}>
        <MTypography variant='subtitle1' weight='bold' color={Color.Gray8}>
          Proof of Affiliated Firm Approval (3210 Letter) is required
        </MTypography>
        <MTypography variant='body1' color={Color.Gray7}>
          Since you stated you are employed by or a member of a registered broker-dealer, securities or futures
          exchange, or securities industry regulatory body (e.g., FINRA, NFA), a 3210 Form Letter from your employer is
          required to process your application.
        </MTypography>
      </div>
    );
  }

  if (category === TradingBlockApplicationCategoryNameDto.Signature) {
    return (
      <div className={Spacing.mb16}>
        <MTypography variant='subtitle1' weight='bold' color={Color.Gray8}>
          Proof of Signature is required
        </MTypography>
        <MTypography variant='body1' color={Color.Gray7}>
          Additional document(s) to validate your Signature are required to process your application.
        </MTypography>
      </div>
    );
  }

  if (category === TradingBlockApplicationCategoryNameDto.GovernmentId) {
    return (
      <div className={Spacing.mb16}>
        <MTypography variant='subtitle1' weight='bold' color={Color.Gray8}>
          Proof of Government Identification is required
        </MTypography>
        <MTypography variant='body1' color={Color.Gray7}>
          Additional document(s) to validate your Government Identification are required to process your application.
        </MTypography>
      </div>
    );
  }

  return null;
};
